module.exports = __webpack_public_path__ + "static/img/6.cbed3f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contact/6.jpg
// module id = clwZ
// module chunks = 1